import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useEstimate } from "@/context/EstimateContext";

export function AddProjectDialog({ open, onOpenChange, editing, onCreated }) {
  const { addProject, renameProject } = useEstimate();
  const [name, setName] = useState("");

  useEffect(() => {
    if (open) setName(editing ? editing.name : "");
  }, [open, editing]);

  const save = () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    if (editing) {
      renameProject(editing.id, trimmed);
    } else {
      const id = addProject(trimmed);
      onCreated?.(id);
    }
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-surface-2 border-border" data-testid="add-project-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">
            {editing ? "Rename Project" : "New Project"}
          </DialogTitle>
          <DialogDescription className="sr-only">Create or rename a project.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-1">
          <div>
            <label className="text-sm font-medium text-muted-foreground">Project name</label>
            <Input
              data-testid="input-project-name"
              autoFocus
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && save()}
              placeholder="e.g. Acme client build"
              className="mt-2 bg-surface border-border"
            />
            <p className="text-xs text-muted-foreground mt-2">
              One project per client or build — each has its own task calculator.
            </p>
          </div>
          <Button
            data-testid="save-project-button"
            onClick={save}
            disabled={!name.trim()}
            className="w-full bg-brand hover:bg-brand-dark text-white font-semibold"
          >
            {editing ? "Save Changes" : "Create Project"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
